import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Text } from '../Text/Text.js';

const defaultProps = {
    variant: 'heading',
    sizing: 'medium',
    weight: 'regular',
    tagName: 'h2',
};
const _Heading = forwardRef((props, ref) => {
    const { children, ...rest } = props;
    return (React.createElement(Text, { ref: ref, ...rest }, children));
});
_Heading.displayName = '_heading';
const Heading = styled(_Heading) ``;
Heading.defaultProps = defaultProps;

export { Heading, defaultProps };
//# sourceMappingURL=Heading.js.map
